import { Typography } from '@mui/material';
import { forwardRef } from 'react';

import { titleTextColor } from 'assets/styles/_palette';

interface ITitleTextProps {
	text: string;
	styles: Record<string, string>;
}

export const TitleText = forwardRef<HTMLSpanElement, ITitleTextProps>(
	({ text, styles, ...props }, ref) => {
		return (
			<Typography
				ref={ref}
				{...props}
				sx={{
					fontSize: '16px',
					fontWeight: '700',
					lineHeight: '25.12px',
					letterSpacing: '0.1px',
					color: titleTextColor,
					...styles,
				}}
			>
				{text}
			</Typography>
		);
	}
);
